import React, { useContext } from "react";

import { Button, ButtonColorEnum, ButtonIconPositionEnum } from "@/components/common/button";
import { Icon, IconSizeEnum, IconTypeEnum } from "@/components/common/icon";
import { UserAvatar } from "@/components/common/userAvatar";
import { UserAvatarTypeEnum } from "@/components/common/userAvatar/types";
import UserInfo from "@/components/common/userInfo";
import GlobalContext from "@/contexts/Global/GlobalContext";
import { reloadPage } from "@/utils/urlUtils";

import { ConnectionTroublesAlertProps } from "./types";

import "../../styles.scss";

const ConnectionTroublesAlert = ({ receiver }: ConnectionTroublesAlertProps) => {
  const { setIsAlertShown, setAlertStatus } = useContext(GlobalContext);

  const clearAlert = () => {
    setAlertStatus(null);
    setIsAlertShown(false);
  };

  return (
    <>
      <div className="modal__top">
        <Icon
          className="modal__close"
          onClick={clearAlert}
          type={IconTypeEnum.Close}
          size={IconSizeEnum.Size32}
        />
      </div>
      <div
        className="modal__content alert__modal"
      >
        {receiver && (
          <UserInfo
            avatar={(
              <UserAvatar
                mobileImage={receiver.mobileImage}
                desktopImage={receiver.desktopImage}
                name={receiver.name}
                userId={receiver.id}
                type={UserAvatarTypeEnum.Call}
              />
            )}
          >
            <div className="alert__modal-icon">
              <Icon type={IconTypeEnum.CallIncoming} size={IconSizeEnum.Size48} />
            </div>
          </UserInfo>
        )}
        <h2 className="h2">Слишком медленный интернет</h2>
        <p>Вы можете подождать загрузку или обновить страницу</p>
        <div className="alert__modal-buttons">
          <div className="alert__modal-button">
            <Button
              text="Обновить страницу"
              icon={IconTypeEnum.Reload}
              iconPosition={ButtonIconPositionEnum.Left}
              onClick={reloadPage}
            />
          </div>
          <div className="alert__modal-button">
            <Button
              text="Подождать загрузку"
              color={ButtonColorEnum.White}
              onClick={clearAlert}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectionTroublesAlert;
